import {
  FileInfo,
  FineAndRejectFileInfo,
  GetFileRequest,
  GetFineAndRejectFileParams,
  PostFineAndRejectFileRequest,
} from '@Src/_basic/object/FileType';
import { Response } from '../../object/ApiType';
import { Api } from '../Api';
import { FileProtocol } from './FileProtocol';

export class FileApi {
  // getFile 取得檔案
  public static getFile(
    params: GetFileRequest,
    onSuccess?: (_data: Array<FileInfo>) => void,
    onFailed?: (res: Response<null>) => void,
    onFinally?: () => void,
  ) {
    const config = {
      params,
    };
    Api.get(FileProtocol.File, config, onSuccess, onFailed, onFinally);
  }

  // deleteFile 刪除檔案
  public static deleteFile(
    id: number | undefined,
    onSuccess?: (data: FileInfo) => void,
    onFailed?: (res: Response<null>) => void,
    onFinally?: () => void,
  ) {
    const config = {
      params: {
        id,
      },
    };
    Api.delete(FileProtocol.File, config, onSuccess, onFailed, onFinally);
  }

  public static getFineAndRejectFile(
    params: GetFineAndRejectFileParams,
    onSuccess?: (_data: Array<FineAndRejectFileInfo>) => void,
    onFailed?: (res: Response<null>) => void,
    onFinally?: () => void,
  ) {
    const config = {
      params,
    };
    Api.get(FileProtocol.FineAndRejectFile, config, onSuccess, onFailed, onFinally);
  }

  public static postFineAndRejectFile(
    params: PostFineAndRejectFileRequest,
    files: FileList,
    onSuccess?: (_data: Array<FineAndRejectFileInfo>) => void,
    onFailed?: (res: Response<null>) => void,
    onFinally?: () => void,
  ) {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      params,
    };

    const formData = new FormData();
    for (let i = 0; i < files?.length; i++) {
      formData.append('files', files[i]);
    }

    Api.post(FileProtocol.UploadFineAndRejectFile, formData, config, onSuccess, onFailed, onFinally);
  }

  public static postFile(
    params: PostFineAndRejectFileRequest,
    files: FileList,
    onSuccess?: (_data: Array<FineAndRejectFileInfo>) => void,
    onFailed?: (res: Response<null>) => void,
    onFinally?: () => void,
  ) {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      params,
    };

    const formData = new FormData();
    for (let i = 0; i < files?.length; i++) {
      formData.append('files', files[i]);
    }

    Api.post(FileProtocol.Upload_File, formData, config, onSuccess, onFailed, onFinally);
  }

  public static uploadPdfFile(
    filename: string,
    blobFile: Blob,
    onSuccess?: (_data: Array<FineAndRejectFileInfo>) => void,
    onFailed?: (res: Response<null>) => void,
    onFinally?: () => void,
  ) {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    };

    const formData = new FormData();
    formData.append('filename', filename);
    formData.append('files', blobFile, filename);

    Api.post(FileProtocol.UploadPdfFile, formData, config, onSuccess, onFailed, onFinally);
  }

  public static checkPdfFile(
    filename: string,
    onSuccess?: (_data: boolean) => void,
    onFailed?: (res: Response<null>) => void,
    onFinally?: () => void,
  ) {
    const url = `${FileProtocol.CheckPdfFile}?filename=${filename}`;
    Api.get(url, undefined, onSuccess, onFailed, onFinally);
  }

  public static downloadPdfFile(
    filename: string,
    onSuccess?: (_data: Array<FineAndRejectFileInfo>) => void,
    onFailed?: (res: Response<null>) => void,
    onFinally?: () => void,
  ) {
    const url = `${FileProtocol.DownloadPdfFile}/${filename}`;
    Api.download(url, undefined, onSuccess, onFailed, onFinally);
  }

  public static auditedPdfFile(
    origin_filename: string,
    file: File,
    onSuccess?: (_data: boolean) => void,
    onFailed?: (res: Response<null>) => void,
    onFinally?: () => void,
  ) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('origin_filename', origin_filename);
    Api.post(FileProtocol.AuditedPdfFile, formData, {}, onSuccess, onFailed, onFinally);
  }
}
